import { FAKE_DB_COLLECTIONS_TOKEN } from '../testing/fake-db-collections-token';
import { FeatureFlags } from './feature-flags-service';

const db = {
  // note: angular-in-memory-web-api is forcing us to use all lower case for this collection name
  featureflags: FeatureFlags.allEnabledFlags
};
export const FeatureDbProvider = { provide: FAKE_DB_COLLECTIONS_TOKEN, multi: true, useValue: db };
